<template>
  <div class="ai-assistant">
    <!-- 主要内容区 -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <!-- AI功能卡片 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <!-- 运营建议 -->
        <div class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex items-center mb-4">
            <div class="p-3 rounded-full bg-red-100 text-red-600">
              <i class="fas fa-lightbulb text-xl"></i>
            </div>
            <h3 class="text-lg font-bold ml-3">运营建议</h3>
          </div>
          <p class="text-gray-600 mb-4">基于数据分析的智能运营建议，帮助提升直播效果</p>
          <button class="w-full bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">
            查看建议
          </button>
        </div>

        <!-- 数据预测 -->
        <div class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex items-center mb-4">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <i class="fas fa-chart-line text-xl"></i>
            </div>
            <h3 class="text-lg font-bold ml-3">数据预测</h3>
          </div>
          <p class="text-gray-600 mb-4">AI驱动的数据趋势预测，助力决策制定</p>
          <button class="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
            开始预测
          </button>
        </div>

        <!-- 智能排期 -->
        <div class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex items-center mb-4">
            <div class="p-3 rounded-full bg-green-100 text-green-600">
              <i class="fas fa-calendar-alt text-xl"></i>
            </div>
            <h3 class="text-lg font-bold ml-3">智能排期</h3>
          </div>
          <p class="text-gray-600 mb-4">基于主播表现和观众偏好的智能排期建议</p>
          <button class="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
            优化排期
          </button>
        </div>
      </div>

      <!-- AI对话界面 -->
      <div class="bg-white rounded-lg shadow-md p-6">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-xl font-bold">AI助手对话</h2>
          <button class="text-gray-600 hover:text-gray-800">
            <i class="fas fa-history"></i>
          </button>
        </div>

        <!-- 对话内容 -->
        <div class="space-y-4 mb-6 h-96 overflow-y-auto">
          <!-- AI消息 -->
          <div class="message-bubble ai">
            <div class="flex items-start">
              <div class="p-2 rounded-full bg-red-100 text-red-600 mr-3">
                <i class="fas fa-robot"></i>
              </div>
              <div>
                <p class="font-bold mb-1">AI助手</p>
                <p>您好！我是您的AI运营助手。我可以帮您：</p>
                <ul class="list-disc list-inside mt-2">
                  <li>分析直播数据并提供优化建议</li>
                  <li>预测未来趋势和潜在机会</li>
                  <li>制定智能排期方案</li>
                  <li>回答运营相关问题</li>
                </ul>
                <p class="mt-2">请问有什么我可以帮您的吗？</p>
              </div>
            </div>
          </div>

          <!-- 用户消息 -->
          <div class="message-bubble user">
            <div class="flex items-start justify-end">
              <div class="text-right">
                <p class="font-bold mb-1">用户</p>
                <p>我想了解一下最近直播数据的情况</p>
              </div>
              <div class="p-2 rounded-full bg-blue-100 text-blue-600 ml-3">
                <i class="fas fa-user"></i>
              </div>
            </div>
          </div>

          <!-- AI消息 -->
          <div class="message-bubble ai">
            <div class="flex items-start">
              <div class="p-2 rounded-full bg-red-100 text-red-600 mr-3">
                <i class="fas fa-robot"></i>
              </div>
              <div>
                <p class="font-bold mb-1">AI助手</p>
                <p>根据最近7天的数据分析，您的直播表现有以下特点：</p>
                <ul class="list-disc list-inside mt-2">
                  <li>平均观看时长：45分钟，比上周增长12%</li>
                  <li>互动率：8.5%，处于行业平均水平</li>
                  <li>礼物收入：¥12,345，环比增长15%</li>
                  <li>新增粉丝：234人，转化率良好</li>
                </ul>
                <p class="mt-2">建议您可以尝试在黄金时段增加直播频次，提升观众粘性。</p>
              </div>
            </div>
          </div>

          <!-- 用户消息 -->
          <div class="message-bubble user">
            <div class="flex items-start justify-end">
              <div class="text-right">
                <p class="font-bold mb-1">用户</p>
                <p>有什么具体的优化建议吗？</p>
              </div>
              <div class="p-2 rounded-full bg-blue-100 text-blue-600 ml-3">
                <i class="fas fa-user"></i>
              </div>
            </div>
          </div>

          <!-- AI消息 -->
          <div class="message-bubble ai">
            <div class="flex items-start">
              <div class="p-2 rounded-full bg-red-100 text-red-600 mr-3">
                <i class="fas fa-robot"></i>
              </div>
              <div>
                <p class="font-bold mb-1">AI助手</p>
                <p>基于您的数据，我建议以下优化策略：</p>
                <ol class="list-decimal list-inside mt-2">
                  <li><strong>内容优化</strong>：增加互动环节，如抽奖、问答等</li>
                  <li><strong>时间调整</strong>：将直播时间调整到19:00-21:00黄金时段</li>
                  <li><strong>话题策划</strong>：提前策划热门话题，提高观众参与度</li>
                  <li><strong>设备升级</strong>：考虑升级摄像头和麦克风，提升画质音质</li>
                </ol>
                <p class="mt-2">这些优化措施预计可以提升20-30%的观众留存率。</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 输入框 -->
        <div class="flex items-center space-x-4">
          <div class="flex-1">
            <input 
              type="text" 
              placeholder="输入您的问题..." 
              class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-red-500"
              v-model="messageInput"
              @keyup.enter="sendMessage"
            >
          </div>
          <button 
            class="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700"
            @click="sendMessage"
          >
            <i class="fas fa-paper-plane mr-2"></i>发送
          </button>
        </div>

        <!-- 快捷消息 -->
        <div class="mt-4">
          <p class="text-sm text-gray-500 mb-2">快捷消息：</p>
          <div class="flex flex-wrap gap-2">
            <button 
              v-for="quickMessage in quickMessages" 
              :key="quickMessage"
              class="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm hover:bg-gray-200"
              @click="selectQuickMessage(quickMessage)"
            >
              {{ quickMessage }}
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AiAssistantPage',
  data() {
    return {
      messageInput: '',
      quickMessages: [
        '查看数据分析',
        '获取运营建议',
        '预测趋势',
        '优化排期',
        '设备推荐'
      ]
    }
  },
  methods: {
    sendMessage() {
      if (this.messageInput.trim()) {
        // 这里可以添加发送消息的逻辑
        console.log('发送消息:', this.messageInput)
        this.messageInput = ''
      }
    },
    selectQuickMessage(message) {
      this.messageInput = message
    }
  }
}
</script>

<style scoped>
.ai-assistant {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.gap-6 {
  gap: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-2 {
  padding: 0.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-lg {
  font-size: 1.125rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-700 {
  color: #374151;
}

.text-red-600 {
  color: #dc2626;
}

.text-blue-600 {
  color: #2563eb;
}

.text-green-600 {
  color: #16a34a;
}

.text-white {
  color: #ffffff;
}

.bg-red-100 {
  background-color: #fee2e2;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.bg-red-600 {
  background-color: #dc2626;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-green-600 {
  background-color: #16a34a;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border {
  border-width: 1px;
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:border-red-500:focus {
  border-color: #dc2626;
}

.hover\:bg-red-700:hover {
  background-color: #b91c1c;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-green-700:hover {
  background-color: #15803d;
}

.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}

.hover\:text-gray-800:hover {
  color: #1f2937;
}

.text-sm {
  font-size: 0.875rem;
}

.w-full {
  width: 100%;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.justify-between {
  justify-content: space-between;
}

.justify-end {
  justify-content: flex-end;
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

.space-y-4 > * + * {
  margin-top: 1rem;
}

.flex-wrap {
  flex-wrap: wrap;
}

.gap-2 {
  gap: 0.5rem;
}

.h-96 {
  height: 24rem;
}

.overflow-y-auto {
  overflow-y: auto;
}

.list-disc {
  list-style-type: disc;
}

.list-decimal {
  list-style-type: decimal;
}

.list-inside {
  list-style-position: inside;
}

/* 消息气泡样式 */
.message-bubble {
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.message-bubble.ai {
  background-color: #f9fafb;
  border-left: 4px solid #dc2626;
}

.message-bubble.user {
  background-color: #eff6ff;
  border-left: 4px solid #2563eb;
}
</style> 